export default __webpack_public_path__ + "99e8a4088ce06c5a4bb038c0a4f18ab6.png";